module.exports = __webpack_public_path__ + "static/media/myMuellerLogo.559afa4f.svg";